import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

export const selector = '.carousel-autoscroll-splide'

export default (
    el = null
) => {
    if (!el)
        return

    console.groupCollapsed('Carousel Autoscroll')

    const carouselSplide = new Splide(selector, {
        type: 'slide',
        drag: 'free',
        autoplay: false,
        autoScroll: false,
        autoWidth: true,
        arrows: false,
        focus: 0,
        pagination: false,
        isNavigation: false,
        mediaQuery: 'min',
        breakpoints: {
            1100: {
                autoScroll: {
                    speed: 0.75
                },
                type: 'loop'
            }
        }
    })

    carouselSplide.mount({ AutoScroll })

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                carouselSplide.destroy()
            })

    // Log instance
    console.log(carouselSplide)

    console.groupEnd()

    return carouselSplide
}
